import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  LOAD_ZONE_LIST,
  CREATE_ZONE,
  EDIT_ZONE_BY_ID,
  LOAD_ZONE_BY_ID,
  DELETE_ZONE,
  EXPORT_ZONES, IMPORT_ZONES, LOAD_ZONE_HISTORY, LOAD_HISTORY_BY_ID,
} from './actions';
import { ZONES_MODULE } from '../../configs/moduleNames';
import {
  createLoadByIdReducer,
  createLoadListReducerWithBegin,
  createOperationStateReducer,
  updateLoadParameterReducer,
} from '../../utils/getCrudConfig';

const initialState = {
  zoneListMeta: {},
  loadingZoneList: false,
  zoneList: [],
  loadingCurrentZone: false,
  currentZone: {},
  loadingCreateZone: false,
  loadingEditZoneById: false,
  loadingDeleteZone: false,
  loadingExportZones: false,
  loadingImportZones: false,
  zoneHistoryMeta: {},
  loadingZoneHistory: false,
  zoneHistory: [],
  loadingCurrentHistory: false,
  currentHistory: {},
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(ZONES_MODULE + LOAD_ZONE_LIST, 'zoneList', 'loadingZoneList'),
  ...updateLoadParameterReducer(ZONES_MODULE + LOAD_ZONE_BY_ID, 'currentZone', 'loadingCurrentZone', {}),
  ...createOperationStateReducer(ZONES_MODULE + CREATE_ZONE, 'loadingCreateZone'),
  ...createOperationStateReducer(ZONES_MODULE + EDIT_ZONE_BY_ID, 'loadingEditZoneById'),
  ...createOperationStateReducer(ZONES_MODULE + DELETE_ZONE, 'loadingDeleteZone'),
  ...createOperationStateReducer(ZONES_MODULE + EXPORT_ZONES, 'loadingExportZones'),
  ...createOperationStateReducer(ZONES_MODULE + IMPORT_ZONES, 'loadingImportZones'),
  ...createLoadListReducerWithBegin(ZONES_MODULE + LOAD_ZONE_HISTORY, 'zoneHistory', 'loadingZoneHistory'),
  ...createLoadByIdReducer(ZONES_MODULE + LOAD_HISTORY_BY_ID, 'currentHistory', 'loadingCurrentHistory'),
}, initialState);

export default reducer;

export const getZoneData = createSelector(
  [state => state[ZONES_MODULE]],
  state => {
    const {
      zoneListMeta,
      loadingZoneList,
      zoneList,
      loadingCurrentZone,
      currentZone,
      loadingCreateZone,
      loadingEditZoneById,
      loadingDeleteZone,
      loadingExportZones,
      loadingImportZones,
      zoneHistoryMeta,
      loadingZoneHistory,
      zoneHistory,
      loadingCurrentHistory,
      currentHistory,
    } = state;
    return {
      zoneListMeta,
      loadingZoneList,
      zoneList,
      loadingCurrentZone,
      currentZone,
      loadingCreateZone,
      loadingEditZoneById,
      loadingDeleteZone,
      loadingExportZones,
      loadingImportZones,
      zoneHistoryMeta,
      loadingZoneHistory,
      zoneHistory,
      loadingCurrentHistory,
      currentHistory,
    };
  },
);
